<div class="modal fade" id="appModal" #appModal tabindex="-1" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-header">
                {{'InstructorSubstitution.Substitute' | translate}}
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <div class="mt-2" translate [translateParams]="{instructorName : instructor.name}">
                    InstructorSubstitution.YouWillReplace</div>

                <div class="mt-4 pb-4">
                    {{'InstructorSubstitution.InstructorName' | translate}}
                    <app-instructor-search-component (instructorSelected)="onSubstitutionInstructorSelected($event)"
                        [clubIds]="club.id | singleItemArray">
                    </app-instructor-search-component>
                </div>

            </div>

            <div class="modal-footer">
                <button class="btn" data-dismiss="modal" (click)="cancel()">{{'General.Cancel' | translate}}</button>
                <button [disabled]="!isInstructorSelected" class="btn btn-success" data-dismiss="modal"
                    (click)="confirm()">{{'General.Confirm' | translate}}</button>
            </div>

        </div>
    </div>
</div>